import { render, staticRenderFns } from "./DashboardResumido.vue?vue&type=template&id=793d0778&scoped=true&"
import script from "./DashboardResumido.vue?vue&type=script&setup=true&lang=js&"
export * from "./DashboardResumido.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DashboardResumido.vue?vue&type=style&index=0&id=793d0778&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793d0778",
  null
  
)

export default component.exports